module.exports = __webpack_public_path__ + "img/animals_04_H.f6db9309.webp";